// extracted by mini-css-extract-plugin
module.exports = {"carrierWrapper":"ClientInsurance_carrierWrapper__2veMP","title":"ClientInsurance_title__35Imk","itemText":"ClientInsurance_itemText__1R_mr"};